import { render } from "./DownloadLogs.vue?vue&type=template&id=72a6dc16"
import script from "./DownloadLogs.vue?vue&type=script&lang=js"
export * from "./DownloadLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__